import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=49d4c60e&scoped=true&"
import script from "./factory.vue?vue&type=script&lang=js&"
export * from "./factory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4c60e",
  null
  
)

export default component.exports